import React from 'react';
import './EmptyState.css';

const illustrations = {
  transactions: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <rect x="35" y="40" width="50" height="8" rx="4" fill="var(--border)" />
      <rect x="35" y="56" width="40" height="8" rx="4" fill="var(--border)" />
      <rect x="35" y="72" width="30" height="8" rx="4" fill="var(--border)" />
      <circle cx="85" cy="85" r="20" fill="var(--bg-card)" stroke="var(--primary)" strokeWidth="3" />
      <path d="M85 77V93M77 85H93" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  webhooks: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <circle cx="45" cy="45" r="12" fill="var(--border)" />
      <circle cx="75" cy="45" r="12" fill="var(--border)" />
      <circle cx="60" cy="75" r="12" fill="var(--border)" />
      <path d="M52 52L53 68" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" />
      <path d="M68 52L67 68" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" />
      <path d="M50 49L70 49" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  ipWhitelist: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <path d="M60 30L90 45V65C90 80 75 92 60 95C45 92 30 80 30 65V45L60 30Z" fill="var(--border)" stroke="var(--secondary)" strokeWidth="3" />
      <path d="M50 60L57 67L72 52" stroke="var(--secondary)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  users: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <circle cx="60" cy="45" r="15" fill="var(--border)" />
      <path d="M35 90C35 75 45 65 60 65C75 65 85 75 85 90" fill="var(--border)" />
      <circle cx="85" cy="80" r="15" fill="var(--bg-card)" stroke="var(--primary)" strokeWidth="3" />
      <path d="M85 72V88M77 80H93" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  logs: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <rect x="35" y="30" width="50" height="60" rx="6" fill="var(--border)" />
      <rect x="42" y="40" width="30" height="4" rx="2" fill="var(--bg-input)" />
      <rect x="42" y="50" width="36" height="4" rx="2" fill="var(--bg-input)" />
      <rect x="42" y="60" width="24" height="4" rx="2" fill="var(--bg-input)" />
      <rect x="42" y="70" width="32" height="4" rx="2" fill="var(--bg-input)" />
      <rect x="42" y="80" width="20" height="4" rx="2" fill="var(--bg-input)" />
    </svg>
  ),
  default: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="50" fill="var(--bg-input)" />
      <rect x="40" y="45" width="40" height="30" rx="4" fill="var(--border)" />
      <circle cx="60" cy="60" r="8" fill="var(--primary)" opacity="0.3" />
      <path d="M56 60L59 63L65 57" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
};

const EmptyState = ({
  type = 'default',
  title = 'No data found',
  description = 'There are no items to display at the moment.',
  action,
  actionLabel
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state-illustration">
        {illustrations[type] || illustrations.default}
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-description">{description}</p>
      {action && actionLabel && (
        <button className="empty-state-action" onClick={action}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
